import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'
import { PlanCards } from '#app/components/marketing/home/plan-cards.tsx'
import {
	marketingWrap,
	SectionHeading,
} from '#app/components/marketing/home/shared.tsx'
import {
	getAppOrigin,
	marketingMeta,
	OG_IMAGE_ALT,
	OG_IMAGE_PATH,
	PRICING_DESCRIPTION,
	SUPPORT_EMAIL,
} from '#app/utils/marketing-meta.ts'
import { PLAN_DETAILS } from '#app/utils/plan-catalog.ts'

const TITLE = 'Pricing | ReefChronicles'

export const meta: MetaFunction = ({ matches }) => {
	const origin = getAppOrigin(matches)
	return marketingMeta({
		title: TITLE,
		description: PRICING_DESCRIPTION,
		url: `${origin}/pricing`,
		image: `${origin}${OG_IMAGE_PATH}`,
		imageAlt: OG_IMAGE_ALT,
		ogTitle: 'ReefChronicles pricing',
		ogDescription: PRICING_DESCRIPTION,
	})
}

export default function PricingRoute() {
	return (
		<main className="bg-[#020617] text-slate-200">
			<section aria-labelledby="pricing-h" className="py-20 md:py-24">
				<div className={marketingWrap}>
					<SectionHeading
						as="h1"
						eyebrow="Plans"
						title="Start free, upgrade when your system grows"
						titleId="pricing-h"
					>
						The dosing calculator is always free. Every plan includes charts,
						maintenance logs and galleries.
					</SectionHeading>
					<PlanCards plans={PLAN_DETAILS} heading="h2" />
					<p className="mt-8 text-center text-slate-400">
						Questions about plans?{' '}
						<a
							href={`mailto:${SUPPORT_EMAIL}`}
							className="text-cyan-300 underline-offset-4 hover:underline"
						>
							{SUPPORT_EMAIL}
						</a>
						{' · '}
						<Link
							to="/#faq"
							className="text-cyan-300 underline-offset-4 hover:underline"
						>
							Read the FAQ
						</Link>
					</p>
				</div>
			</section>
		</main>
	)
}
